import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CustomerProposalWrapperJobDetails } from '../modules/JobDetails/components/ProposalTab/customer-view/CustomerProposalWrapperJobDetails';

export const Route = createFileRoute('/proposal-job-details-customer-preview/$quoteDocumentId')({
  component: RouteComponent,
  params: z.object({
    quoteDocumentId: z.coerce.number().positive(),
  }),
  head: () => ({
    meta: [
      {
        title: 'Customer Proposal Preview - Job Details (Internal)',
      },
    ],
  }),
});

function RouteComponent() {
  const { quoteDocumentId } = Route.useParams();

  return (
    <CustomerProposalWrapperJobDetails
      quoteDocumentId={quoteDocumentId}
      reload={() => {
        window.location.reload();
      }}
    />
  );
}
